import { FirebaseOptions, getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import {
  getAnalytics,
  initializeAnalytics,
  isSupported as isAnalyticsSupported,
  setAnalyticsCollectionEnabled,
  setConsent,
} from "firebase/analytics";
import { resolveAnalyticsStream } from "../utils/analyticsStream";

const stagingConfig = {
  apiKey: "AIzaSyCZmcUm3VKdmBixKES4Gip3GeKefYk9GA8",
  authDomain: "peak-x-staging.firebaseapp.com",
  projectId: "peak-x-staging",
  storageBucket: "peak-x-staging.firebasestorage.app",
  messagingSenderId: "710805219697",
  appId: "1:710805219697:web:835bf45ac524611f6eaed0",
};

const productionConfig = {
  apiKey: "AIzaSyD_bal8834MIFxoc05zfWh7aI5K7uR_0oQ",
  authDomain: "peak-x-937b6.firebaseapp.com",
  projectId: "peak-x-937b6",
  storageBucket: "peak-x-937b6.firebasestorage.app",
  messagingSenderId: "377620642931",
  appId: "1:377620642931:web:704b27d79e552b6fe53e06",
};

const isProduction =
  process.env.REACT_APP_FORCE_PRODUCT_MODE === "true" ||
  (typeof window !== "undefined" &&
    (window.location.hostname === "peakxv2.web.app" ||
      window.location.hostname === "peak.app" ||
      window.location.hostname === "www.peak.app" ||
      window.location.hostname === "programs.peak.app" ||
      window.location.hostname === "peak-education.web.app" ||
      window.location.hostname === "peak-education.firebaseapp.com"));

const firebaseConfig = isProduction ? productionConfig : stagingConfig;

export { isProduction };

if (!firebaseConfig.apiKey || !firebaseConfig.projectId) {
  throw new Error("Firebase configuration is missing required fields.");
}

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const functions = getFunctions(app, "us-central1");

let analytics: ReturnType<typeof getAnalytics> | null = null;
// Production web app "Peak Education" in peak-x-937b6. Staging has no stream yet.
const productionAnalytics = {
  appId: "1:377620642931:web:5d55564f395e18c0e53e06",
  measurementId: "G-6HYPNC53EN",
};
const analyticsStream = resolveAnalyticsStream(
  firebaseConfig.appId,
  isProduction ? productionAnalytics.appId : process.env.REACT_APP_GA_APP_ID_STAGING,
  isProduction
    ? productionAnalytics.measurementId
    : process.env.REACT_APP_GA_MEASUREMENT_ID_STAGING,
);
const isLocalhost =
  typeof window !== "undefined" && window.location.hostname.startsWith("localhost");

if (analyticsStream && !isLocalhost) {
  const analyticsOptions: FirebaseOptions = {
    ...firebaseConfig,
    appId: analyticsStream.appId,
    measurementId: analyticsStream.measurementId,
  };
  const analyticsApp =
    getApps().find((item) => item.name === "peak-education-analytics") ??
    initializeApp(analyticsOptions, "peak-education-analytics");
  setConsent({
    analytics_storage: "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });
  isAnalyticsSupported()
    .then((supported) => {
      if (!supported) return;
      analytics = initializeAnalytics(analyticsApp, {
        config: { send_page_view: false },
      });
      setAnalyticsCollectionEnabled(analytics, false);
    })
    .catch((error) => {
      console.warn("Analytics not supported:", error);
    });
}

export { analytics };
export default app;
